import { useEffect, useRef } from "react";
import { OfferCard } from "@/components/OfferCard";

// Native horizontal scroll (finger-draggable) with a gentle auto-advance that pauses on interaction.
export const OffersMarquee = ({ offers, renderItem, speed = 0.035, testId = "destinations-carousel" }) => {
  const ref = useRef(null);
  const paused = useRef(false);
  const resumeTimer = useRef(null);
  const items = [...offers, ...offers, ...offers];

  useEffect(() => {
    const el = ref.current;
    let raf;
    let last = performance.now();
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let pos = el.scrollWidth / 3;
    el.scrollLeft = pos;
    const tick = (now) => {
      const dt = Math.min(now - last, 50);
      last = now;
      if (!paused.current && !reduce) pos += dt * speed;
      else pos = el.scrollLeft;
      const third = el.scrollWidth / 3;
      if (pos >= third * 2) pos -= third;
      if (pos <= 1) pos += third;
      if (Math.abs(el.scrollLeft - pos) >= 1) el.scrollLeft = pos;
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => {
      cancelAnimationFrame(raf);
    };
  }, []);

  const pause = () => {
    paused.current = true;
    clearTimeout(resumeTimer.current);
  };
  const resume = () => {
    clearTimeout(resumeTimer.current);
    resumeTimer.current = setTimeout(() => {
      paused.current = false;
    }, 1800);
  };

  return (
    <div
      ref={ref}
      data-testid={testId}
      onPointerEnter={pause}
      onPointerLeave={resume}
      onTouchStart={pause}
      onTouchEnd={resume}
      onWheel={() => {
        pause();
        resume();
      }}
      className="no-scrollbar flex gap-4 overflow-x-auto px-5 pb-6 pt-2 sm:gap-6 sm:px-10"
    >
      {items.map((o, i) => {
        const id = i < offers.length * 2 && i >= offers.length ? o.id : undefined;
        return renderItem
          ? renderItem(o, i, id)
          : <OfferCard key={`${o.id}-${i}`} offer={o} testId={id && `destination-card-${id}`} />;
      })}
    </div>
  );
};
